import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";

const BrandView = () => {
  const [BrandUser, setBrandUser] = useState({
    brand_logo: "",
    brand_name: "",
    manuf_name: "",
    manuf_state:"",
    status: "",
  });
  const { id } = useParams();

  useEffect(() => {
    const BrandData = async () => {
      try {
        const response = await axios.post(
          "https://cyberathon.com/multivendor/index.php/Api/Master_controller/get_brand_by_id",
          {
            brand_id: id
          }
        );
        setBrandUser(response.data.data);
      } catch (error) {
        console.error("There was an error!", error);
      }
    };
    BrandData();
  }, [id]);

  return (
    <div className="page-content">
      {/* Start Container Fluid */}
      <div className="container-fluid">
        {/* ========== Page Title Start ========== */}
        <div className="row">
          <div className="col-12">
            <div className="page-title-box">
              <h4 className="mb-0 fw-semibold">SubCategories View</h4>
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item">
                  <Link to="javascript: void(0);">SubCategories</Link>
                </li>
                <li className="breadcrumb-item active">SubCategories View</li>
              </ol>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-xl-12">
            <div className="card category-view">
            <div className="cross-icon">
              <Link to="/brand-list">
              <i className="fa-solid fa-circle-xmark"></i>
              </Link>
            </div>
              <div>
                <img
                  src={`https://cyberathon.com/multivendor/${BrandUser.brand_logo}`}
                  width={600} height={400}
                />
              </div>
              <strong>Brand Name</strong>
              <p>{BrandUser.brand_name}</p>
              <strong>Manufacturer Name</strong>
              <p>{BrandUser.manuf_name}</p>
              <strong>Manufacturer State</strong>
              <p>{BrandUser.manuf_state}</p>
            </div>
          </div>
        </div>
      </div>
      {/* End Container Fluid */}
      {/* ========== Footer Start ========== */}
      <footer className="footer">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12 text-center">
              © Venton. Crafted by{" "}
              <iconify-icon
                icon="iconamoon:heart-duotone"
                className="fs-18 align-middle text-danger"
              />{" "}
              <Link to className="fw-bold footer-text" target="_blank">
                Techzaa
              </Link>
            </div>
          </div>
        </div>
      </footer>
      {/* ========== Footer End ========== */}
    </div>
  );
};

export default BrandView;
